import Helper from './Helper';

class prevNextBack {
  constructor(config = {}) {
    const {
      backPlaceholderSelector,
      prevPlaceholderSelector,
      nextPlaceholderSelector,
      backSelector,
      prevSelector,
      nextSelector
    } = config;


    this.backPlaceholder = document.querySelector(backPlaceholderSelector);
    this.prevPlaceholder = document.querySelector(prevPlaceholderSelector);
    this.nextPlaceholder = document.querySelector(nextPlaceholderSelector);
    if (!this.backPlaceholder || !this.prevPlaceholder || !this.nextPlaceholder) {
      return;
    }
    this.id = document.querySelector(backPlaceholderSelector).dataset.id;
    this.backs = document.querySelectorAll(backSelector);
    this.prevs = document.querySelectorAll(prevSelector);
    this.nexts = document.querySelectorAll(nextSelector);

    if(this.backs){
      this.bindEvents(this.backs, this.backPlaceholder, 'beforebegin');
    }

    if(this.prevs){
      this.bindEvents(this.prevs, this.prevPlaceholder, 'beforebegin', '.prevnext--prev:not(.header__pnb)');
    }

    if(this.nexts){
      this.bindEvents(this.nexts, this.nextPlaceholder, 'afterend', '.prevnext--next:not(.header__pnb)');
    }
  }

  bindEvents(elements, placeholder, position, hide){
    elements.forEach(element => {
      if(element.dataset.id == this.id){
        placeholder.insertAdjacentElement(position, element);
        if(hide){
          document.querySelector(hide).remove();
        }
      }
    });
  }
}

export default prevNextBack;
